define(
    'viewmodels/status',[
        "viewmodels/ViewModel",
        "plugins/router",
        "i19n!i19n/strings",
        "providers/dataprovider",
        "viewmodels/controller",
        "services/session"
    ],
    function (ViewModel, router, i19n, dataProvider, shell, session) {
        var vm = new ViewModel(
        {
            i19n: i19n,
            id: '',
            isLoading: ko.observable(false),
            title: ko.observable(''),
            message: ko.observable('')
        });

        //id=1 server status
        //id=2 invalid fileplan instance
        //id=3 subscription expiry
        vm.activate = function (ctx) {
            vm.id = ctx.substring(3, ctx.length);
            
            if (vm.id == '1') {
                vm.title('Server Status');
                vm.message('The server status message goes here. this is a long text description of what a message from server look like.');
            }

            if (vm.id == '2') {
                vm.title('Invalid fileplan instance web address');
                vm.message('Please correct the web address or contact your fileplan instance administrator for assistance.');
            }

            if (vm.id == '3') {
                vm.title('Subscription Verfication Failed');
                vm.message('Cannot verify your subscription. Please try again later.');
            }
        };
        vm.attached = function () {
           
        };

        return vm;

        function _navigate(title, delay) {
            shell.isNavigating(true, title);
            setTimeout(function () {
                shell.isNavigating(false);
            }, delay);
        }
    }
);
